import { detectGeneratedArtifactKind } from './generatedArtifactAssistantPayloadBody.js'
import { NAME_AFTER_RE, normalizeArtifactPrompt } from './generatedArtifactAssistantPayloadPatterns.js'

const KIND_DETAILS = {
  doc: {
    extension: 'docx',
    fallbackName: 'Untitled Document',
    leadLine: "Sure, I'll create that document for you.",
    description: 'Blank document · Ready to edit',
  },
  spreadsheet: {
    extension: 'xlsx',
    fallbackName: 'Untitled Workbook',
    leadLine: "Sure, I'll create that spreadsheet for you.",
    description: 'Starter workbook · Ready to edit',
  },
  html: {
    extension: 'html',
    fallbackName: 'index',
    leadLine: "Sure, I'll create that app for you.",
    description: 'HTML app · Ready to preview',
  },
}

function extractName(text) {
  const match = normalizeArtifactPrompt(text).match(NAME_AFTER_RE)
  return match?.[1]?.trim().replace(/[\\/:*?"<>|]+/g, '') || ''
}

export function resolveGeneratedArtifactDetails(text) {
  const artifactKind = detectGeneratedArtifactKind(text)
  if (!artifactKind) return null
  const details = KIND_DETAILS[artifactKind]
  const displayTitle = extractName(text) || details.fallbackName
  return {
    artifactKind,
    displayTitle,
    fileName: `${displayTitle}.${details.extension}`,
    leadLine: details.leadLine,
    description: details.description,
  }
}
